import { Switch } from 'react-router-dom'
import RegistrationPage from 'src/components/common/Registration/RegistrationPage'
import Otp from 'src/components/Registration/Otp'
import Registration from 'src/components/Registration/Registration'
import RouteMiddleware from 'src/components/common/RouteMiddleware'

const RegistrationMain = () => {
  return (
    <RegistrationPage>
      <Switch>
        <RouteMiddleware
          title={'Individual Registration'}
          path='/individual/dashboard/register'
          exact
          component={Registration}
        />
        <RouteMiddleware
          title={'Registration OTP Page'}
          path='/individual/dashboard/register/otp'
          exact
          component={Otp}
        />
      </Switch>
    </RegistrationPage>
  )
}

export default RegistrationMain
